import { useCallback } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useStepbarSteps } from './useStepbarSteps'

export const useStepbarNavigation = () => {
  const pathName = useLocation().pathname
  const navigate = useNavigate()
  const { getStepsStatus, steps } = useStepbarSteps()
  const stepIndex = steps.findIndex((step) => step.path === pathName)
  const currentStep = steps[stepIndex]
  const nextStep = steps.slice(stepIndex + 1).find((step) => !step.disabled)
  const previousStep = steps
    .slice(0, stepIndex)
    .reverse()
    .find((step) => !step.disabled)
  const canNavigateBackward = Boolean(previousStep)
  const canNavigateForward = currentStep?.completed && Boolean(nextStep)

  const NO_BACKWARD_NAVIGATION_ROUTES = ['/escolha-usuario']

  const isDisabledBackwardButton =
    NO_BACKWARD_NAVIGATION_ROUTES.includes(pathName) ||
    stepIndex === 0 ||
    !canNavigateBackward

  const isDisabledForwardButton =
    stepIndex === steps.length - 1 || !canNavigateForward

  const handleForwardNavigation = useCallback(() => {
    if (!canNavigateForward || !nextStep) {
      return
    }

    navigate(nextStep.path)
  }, [canNavigateForward, nextStep, navigate])

  const handleBackwardNavigation = useCallback(() => {
    if (!canNavigateBackward || !previousStep) {
      return
    }

    navigate(previousStep.path)
  }, [canNavigateBackward, previousStep, navigate])

  const getNextRequiredStep = useCallback(() => {
    const updatedSteps = getStepsStatus()
    const nextStepToNavigate =
      updatedSteps.find((step) => !step.completed && !step.disabled) ||
      updatedSteps[updatedSteps.length - 1]

    return nextStepToNavigate
  }, [getStepsStatus])

  const goToNextRequiredStep = useCallback(
    (replace = false) => {
      const nextStepToNavigate = getNextRequiredStep()

      replace
        ? navigate(nextStepToNavigate.path, { replace: true })
        : navigate(nextStepToNavigate.path)
    },
    [getNextRequiredStep, navigate]
  )

  return {
    goToNextRequiredStep,
    handleBackwardNavigation,
    handleForwardNavigation,
    isDisabledBackwardButton,
    isDisabledForwardButton
  }
}
